angular.module('bmsApp.settings').controller('AccountDefaultsCtrl',
    function ($scope, $log, $state, SetupSvc, notify, $q, AuthService, VATRateSvc, SalesTypeSvc, AccountDefaultsSvc) {

        function init() {
            self.loading = true;
            var promises = {
                vatRates: VATRateSvc.index(),
                salesTypes: SalesTypeSvc.index(),
                defaults: AccountDefaultsSvc.index()
            };

            $q.all(promises).then(function (responses) {
                self.options.vatRates = responses.vatRates.data.vat_rate_collection;
                self.options.salesTypes = responses.salesTypes.data.sales_type_collection;
                self.form.general_preferences = angular.extend({}, responses.defaults.data.general_preferences, {
                    preferred_vat_rate: {
                        vat_rate: responses.defaults.data.general_preferences.preferred_vat_rate
                    },
                    preferred_sales_type: {
                        id: responses.defaults.data.general_preferences.preferred_sales_type_id
                    }
                });

                self.loading = false;
            });
        }

        function submit() {

        }

        var self = {
            loading: false,
            processing: false,
            vat_rates: null,
            options: {
                vatRates: null,
                salesTypes: null
            },
            form: {
                general_preferences: null
            },
            methods: {
                submit: submit
            }
        };

        $scope.accountDefault = self;

        init();

    });



